import React from 'react'
import styled, { css } from 'styled-components'
import SimpleBoardRow from '../components/SimpleBoardRow'

import FlipMove from 'react-flip-move'
import { useStore } from '../zustandStore'
import { shallow } from 'zustand/shallow'

const SimpleBoardTable = ({
  players,
  hasOddOffset,
  scaleBy,
  scaleByOnPhone,
  onClickPlayerRow = () => () => {},
  borderThicknessPx,
  wrapperClassName = '',
  tableClassName = '',
  rowClassName = '',
  flashingPlayerSlugs = [],
  disableAllAnimations = false,
  groupTitle = ''
}) => {

  const livePlayerSlugs = useStore(state => (state.obsState && state.obsState.livePlayerSlugs) || [], shallow)
  const featuredPlayerSlug = useStore(state => (state.obsState && state.obsState.featuredPlayerSlug), shallow)
  const publicAppSettings = useStore(state => (state.publicAppSettings), shallow)
  const hasDivisions = useStore(state => (state.event.hasDivisions), shallow)
  const isConcluded = useStore(state => (state.event.isConcluded), shallow) 

  const playerCount = useStore(state => (state.players.length), shallow)
  const maxPossibleRankDigits = String(playerCount).length

  return (
    <StyledTableWrapper className={wrapperClassName}>
      {borderThicknessPx && !groupTitle && (
        <BorderTop className='row' key='bordertop' playersPresent={players && players.length > 0} thickness={borderThicknessPx} />
      )}
      <StyledTableFlipMove
        enterAnimation={null}
        leaveAnimation={null}
        disableAllAnimations={disableAllAnimations || publicAppSettings.movementAnimations === false}
        // maintainContainerHeight={players && players.length > 1}
        // maintainContainerHeight
        // onStartAll={(childElements, domNodes) => {debugger} }
        className={`${hasOddOffset ? 'with-odd-offset' : ''} ${tableClassName} ${groupTitle ? 'no-border-top' : ''}`}
      >
        {groupTitle ? (
          <GroupHeader className='group-header' key='title'>{groupTitle}</GroupHeader>
        ) : null}

        {players.map((player, i) => {
          return <StyledSimpleBoardRow
            key={player.slug}
            player={player}
            className={`${i % 2 === 0 ? 'row-even' : 'row-odd'} ${rowClassName}`}
            scaleBy={scaleBy}
            scaleByOnPhone={scaleByOnPhone}
            onClick={onClickPlayerRow(player.slug)}
            isLive={livePlayerSlugs.includes(player.slug)}
            shouldFlash={flashingPlayerSlugs.includes(player.slug)}
            isFeatured={player.slug === featuredPlayerSlug}
            rankDigits={maxPossibleRankDigits}
            prependBingoPoints={!isConcluded}
            rankOverrideKey={hasDivisions ? 'divisionRank' : null}
          />
        })}
      </StyledTableFlipMove>
      {borderThicknessPx && players.length > 0 && (
        <BorderBottom className='border-bottom' key='borderbottom' playersPresent={players && players.length > 0} thickness={borderThicknessPx}/>
      )}
    </StyledTableWrapper>
  )
}

export default SimpleBoardTable

const Border = styled.div`
  margin: 0;
  width: 100%;

  @media only screen and (max-width: ${() => `${window.phoneCutoffSizePx}px`}) and (orientation: portrait) {
    padding-right: 2%;
    padding-left: 2%;
    width: 96%;
  }
`

const BorderTop = styled(Border)`
  ${props => props.thickness && css`
    border-bottom: ${props => props.playersPresent ? props.thickness : 0}px solid #aaa!important;
  `}
`
const BorderBottom = styled(Border)`
  ${props => props.thickness && css`
    border-top: ${props => props.playersPresent ? props.thickness : 0}px solid #aaa!important;
  `}
`

const StyledTableWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  /* margin-left: 0.4em;
  margin-right: 0.4em; */

   ${'' /* alternating row colors */}

  .row-odd {
    background-color: #0000;
    border-top: 1px solid #0000;
    border-bottom: 1px solid #0000;
  }
  .row-even {
    background-color: var(--every-other-row-color);
    border-top: 1px solid var(--every-other-row-color);
    border-bottom: 1px solid var(--every-other-row-color);
  }
  @media only screen and (max-width: ${() => `${window.phoneCutoffSizePx}px`}) and (orientation: portrait) {
    .with-odd-offset {
      .row-odd {
        background-color: var(--every-other-row-color);
      }
      .row-even {
        background-color: #0000;
      }
    }
    .row, .group-header {
      font-size: min(7vw, 37px);
      max-width: 600px;
    }
  }
`
const StyledTableFlipMove = styled(FlipMove)`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  max-width: 95vw;


  @media only screen and (max-width: ${() => `${window.phoneCutoffSizePx}px`}) and (orientation: portrait) {
    /* width: 95%; */
  }
`

const StyledSimpleBoardRow = styled(SimpleBoardRow)`
  font-size: 1.6em;
`

const GroupHeader = styled.div`
  width: 100%;
  font-size: 1.3em;
  color: #ccc;
  /* justify-content: center; */
  border-top: 2px solid #aaa;
  border-bottom: 2px solid #aaa;
  box-sizing: border-box;
  padding-bottom: 0.07em;
  padding-left: 0.4em;
  /* background-color: #8e44b03d; */
  background: var(--gradient-background);
`